"use client";

import { TInformationSection } from "@shared/types";
import { ButtonLink } from "@shared/ui";
import Image from "next/image";

export function InformationSection({ title, description, imageDesktop, imageMobile, button }: TInformationSection) {
  return (
    <section className="py-12 lg:py-[120px] relative overflow-hidden bg-white">
      <div className="container relative">
        <div className="flex flex-col lg:flex-row gap-10 sm:gap-20 lg:gap-10 lg:items-center">
          {imageDesktop?.data?.attributes?.url && (
            <Image
              className="hidden lg:block flex-shrink-0 object-contains w-[20rem] lg:w-[37.5rem] h-auto"
              src={imageDesktop?.data?.attributes?.url}
              height={imageDesktop?.data?.attributes?.height}
              width={imageDesktop?.data?.attributes?.width}
              alt={imageDesktop?.data?.attributes?.alternativeText || "Information Section Image"}
            />
          )}

          {imageMobile?.data?.attributes?.url && (
            <Image
              className="lg:hidden object-contains w-full h-auto"
              src={imageMobile?.data?.attributes?.url}
              height={imageMobile?.data?.attributes?.height}
              width={imageMobile?.data?.attributes?.width}
              alt={imageMobile?.data?.attributes?.alternativeText || "Information Section Image Mobile"}
            />
          )}

          <div className="flex flex-col space-y-6">
            <h3 className="text-5xl md:text-[64px] leading-[112%] font-bold lg:max-w-[40rem] text-left">{title}</h3>
            <p className="text-xl lg:text-2xl lg:max-w-[36rem] text-left text-gray-700">{description}</p>

            {button?.href && (
              <div className="flex-none">
                <ButtonLink {...button} />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
